import { useState } from "react";
import api from "../services/api";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!username || !password) {
      alert("Please enter username and password");
      return;
    }

    try {
      setLoading(true);

      const res = await api.post("/auth/login", {
        username,
        password
      });

      // Save token
      localStorage.setItem("token", res.data.token);

      // Save role properly
        if (res.data.user?.role) {
          localStorage.setItem("role", res.data.user.role);
        }

      onLogin();

    } catch (err) {
      alert(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        
        {/* Logo */}
        <img
          src="/logo.png"
          alt="Company Logo"
          style={styles.logo}
        />

        <h2 style={styles.title}>Mooving Grills POS</h2>
        <p style={styles.subtitle}>
          Please login with your assigned credentials
        </p>

        <input
          style={styles.input}
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
        />

        <input
          style={styles.input}
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        <button
          style={{
            ...styles.button,
            opacity: loading ? 0.7 : 1,
            cursor: loading ? "not-allowed" : "pointer"
          }}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? (
            <span style={styles.spinner}></span>
          ) : (
            "Login"
          )}
        </button>

        <p style={styles.instructions}>
          • Cashier: Order Punch & Billing <br />
          • Chef: Kitchen Display (KDS) <br />
          • Dispatch: Order Dispatch <br />
          • Manager: Full Access
        </p>

      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #1f2937, #111827)"
  },
  card: {
    background: "#ffffff",
    padding: "40px",
    borderRadius: "12px",
    width: "350px",
    textAlign: "center",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)"
  },
  logo: {
    width: "80px",
    marginBottom: "15px"
  },
  title: {
    marginBottom: "5px"
  },
  subtitle: {
    fontSize: "14px",
    marginBottom: "20px",
    color: "#555"
  },
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "15px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px"
  },
  button: {
    width: "100%",
    padding: "10px",
    background: "#111827",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "15px",
    fontWeight: "bold",
    marginBottom: "15px"
  },
  instructions: {
    fontSize: "12px",
    color: "#666",
    textAlign: "left",
    marginTop: "10px"
  },
  spinner: {
    width: "18px",
    height: "18px",
    border: "3px solid #f3f3f3",
    borderTop: "3px solid #ffffff",
    borderRadius: "50%",
    display: "inline-block",
    animation: "spin 1s linear infinite"
  }
};